module.exports = __webpack_public_path__ + "img/logo_portugal2020.f25343ea.png";